class FmImageWithText extends HTMLElement {
  connectedCallback() {
    this._items = Array.from(this.querySelectorAll('[data-fm-accordion-item]'));

    if (this._items.length <= 1) {
      return;
    }

    this._onClick = this._handleClick.bind(this);
    this._onBlockSelect = this._handleBlockSelect.bind(this);

    this.addEventListener('click', this._onClick);
    this.addEventListener('shopify:block:select', this._onBlockSelect);
  }

  disconnectedCallback() {
    if (this._onClick) {
      this.removeEventListener('click', this._onClick);
    }

    if (this._onBlockSelect) {
      this.removeEventListener('shopify:block:select', this._onBlockSelect);
    }
  }

  _handleClick(event) {
    const trigger = event.target.closest('[data-fm-accordion-trigger]');

    if (!trigger || !this.contains(trigger)) {
      return;
    }

    const item = trigger.closest('[data-fm-accordion-item]');

    if (!item) {
      return;
    }

    this._setOpen(item, !item.classList.contains('is-open'));
  }

  _handleBlockSelect(event) {
    const item = event.target.closest('[data-fm-accordion-item]');

    if (!item || !this.contains(item)) {
      return;
    }

    this._setOpen(item, true);
  }

  _setOpen(item, open) {
    const trigger = item.querySelector('[data-fm-accordion-trigger]');
    const panel = item.querySelector('[data-fm-accordion-panel]');

    item.classList.toggle('is-open', open);

    if (trigger) {
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    if (panel) {
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    }
  }
}

if (!customElements.get('fm-image-with-text')) {
  customElements.define('fm-image-with-text', FmImageWithText);
}
